// Stale-build detection store.
// Fetch wrapper writes here when X-App-Version diverges from __BUILD_HASH__;
// banner + write-block read from here. Lives outside React because fetch.ts
// is module-level — useSyncExternalStore bridges it back into the React tree.

import { useSyncExternalStore } from "react";

const BUILD_HASH = typeof __BUILD_HASH__ !== "undefined" ? __BUILD_HASH__ : "dev";

let staleBuild = false;
let staleServerVersion: string | null = null;
const listeners = new Set<() => void>();

export function getBuildHash(): string {
	return BUILD_HASH;
}

export function isBuildStale(): boolean {
	return staleBuild;
}

export function getStaleServerVersion(): string | null {
	return staleServerVersion;
}

export function markBuildStale(serverVersion: string): void {
	if (staleBuild) return;
	staleBuild = true;
	staleServerVersion = serverVersion;
	for (const fn of listeners) fn();
}

function subscribe(callback: () => void): () => void {
	listeners.add(callback);
	return () => listeners.delete(callback);
}

export function useStaleBuild(): boolean {
	return useSyncExternalStore(subscribe, isBuildStale, () => false);
}

/** The version the server reported once this build went stale, or null while it
 * has not. Callers that act on staleness need the version to act only once per
 * deploy, not merely to know that something changed. */
export function useStaleServerVersion(): string | null {
	return useSyncExternalStore(subscribe, getStaleServerVersion, () => null);
}
